import axios from 'axios';
import { useEffect, useState } from 'react';
import { Alert, Button, Modal, Table } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { EVALUACIONAPI, USERAPI } from '../../../../../../const';
import { CvUsuarioCongelado } from '../../../../../CV/CvUsuarioCongelado';
import Seccion from '../../../../../CV/Seccion';
import FullLoading from '../../../../../CompUtils/FullLoading';
import { activoSelector } from '../../../gestionConcursoSlice';
import { getPuesto, usePostulacionesPuesto } from '../../restPostulacionesPuesto';
import TablaValidacionRequisitos from './TablaValidacionRequisitos';

export const EvaluacionDocumental = () => {
  const { idPuesto } = useParams();
  const [nombre, setNombre] = useState('');
  const [apellido, setApellido] = useState('');
  const [dni, setDni] = useState('');
  const [fechaDeNacimiento, setFechaDeNacimiento] = useState('');
  const [nacionalidad, setNacionalidad] = useState('');
  const [cud, setCud] = useState('');
  const [procesado, setProcesado] = useState(false);
  const [idPostulantePuesto, setIdPostulantePuesto] = useState(0);
  const [botoneraRechazadosSt, setBotoneraRechazadosSt] = useState(false);
  const history = useHistory();
  const concurso = useSelector(activoSelector);
  const { esCoordinadorConcursal } = concurso;

  const calcularEdad = (fechaNacimiento) => {
    const fecha = new Date();
    const dia = fecha.getDate();
    const mes = fecha.getMonth() + 1;
    const anio = fecha.getFullYear();

    const fechaNacimientoArr = fechaNacimiento.split('-');
    const diaNacimiento = fechaNacimientoArr[2];
    const mesNacimiento = fechaNacimientoArr[1];
    const anioNacimiento = fechaNacimientoArr[0];

    let edad = anio - anioNacimiento;
    if (mes < mesNacimiento) {
      edad--;
    } else if (mes === mesNacimiento) {
      if (dia < diaNacimiento) {
        edad--;
      }
    }
    return edad;
  };

  const [requisitosCargados, setRequisitosCargados] = useState([]);

  const [, setErrorMsg] = useState('');

  const { postulantes, loading } = usePostulacionesPuesto();

  const dispatch = useDispatch();
  const [showCv, setShowCv] = useState(false);

  const handleClose = () => {
    setShowCv(false);
    setOcultarBotonCv(false);
    history.go(0);
  };

  const [idUser, setIdUser] = useState();
  const [ocultarBotonCv, setOcultarBotonCv] = useState(false);
  const handleShow = (
    idUsuario,
    idPostulantePuesto,
    nombre,
    apellido,
    dni,
    fechaNacimiento,
    nacionalidad,
    numCud,
    procesado,
    botoneraRechazados,
  ) => {
    axios
      .get(`${EVALUACIONAPI}/documental/detalle-postulacion/requisitos/${idPostulantePuesto}`)
      .then((res) => {
        setRequisitosCargados(res.data);
      })
      .catch((error) => {
        if (error.response) {
          // Request made and server responded
          setErrorMsg(error.response.data.message);
        } else if (error.request) {
          // The request was made but no response was received
          setErrorMsg(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          setErrorMsg(error.message);
        }
      });
    setIdUser(idUsuario);
    setNombre(nombre);
    setApellido(apellido);
    setFechaDeNacimiento(fechaNacimiento);
    setNacionalidad(nacionalidad);
    setCud(numCud);
    setDni(dni);
    setShowCv(true);
    setOcultarBotonCv(true);
    setIdPostulantePuesto(idPostulantePuesto);
    setProcesado(procesado);
    setBotoneraRechazadosSt(botoneraRechazados);
  };

  const handleAdmitir = (idPostulantePuestoLocal) => {
    axios
      .patch(`${EVALUACIONAPI}/documental/detalle-postulacion/${idPostulantePuestoLocal}/aprobar`, {
        listaRequisitos: requisitos,
      })
      .then((res) => {
        history.go(0);
      })
      .catch((err) => {
        console.log(err.data);
      });
  };

  const handleRechazar = (idPostulantePuestoLocal) => {
    axios
      .patch(
        `${EVALUACIONAPI}/documental/detalle-postulacion/${idPostulantePuestoLocal}/rechazar`,
        {
          listaRequisitos: requisitos,
        },
      )
      .then((res) => {
        history.go(0);
      })
      .catch((err) => {
        console.log(err.response.status);
        console.log(err.response.data);
      });
  };

  const handleVerCUD = async (idUsuario) => {
    await axios
      .get(`${USERAPI}/usuarios/cud/${idUsuario}`, {
        responseType: 'blob',
      })
      .then((res) => {
        const file = new Blob([res.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(file);

        window.open(url);
        return url;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const [requisitos, setRequisitos] = useState([]);

  const handleRequisitosValidados = (requisito) => {
    setRequisitos(requisito);
  };

  useEffect(() => {
    if (!esCoordinadorConcursal) {
      return (
        <Alert variant="danger">
          <h1>No tiene permisos para operar en esta sección!</h1>
          <h3>Por favor contacte al administrador si es un error!</h3>
        </Alert>
      );
    }
    dispatch(getPuesto({ idPuesto }));
  }, []);

  const ColorTr = styled.tr`
    background-color: ${({ procesado }) => (procesado ? 'lightgreen!important' : undefined)};
  `;

  return (
    <>
      <FullLoading show={loading} />
      {requisitosCargados?.length > 0 && (
        <Modal
          size="lg"
          style={{ maxWidth: '100%', width: '100%' }}
          show={showCv}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}>
          <Modal.Header>
            <h3>
              {nombre} {apellido} - {dni}
            </h3>
          </Modal.Header>
          <br />
          <h6 className="ml-3">{`Edad: ${calcularEdad(fechaDeNacimiento)}`}</h6>
          <h6 className="ml-3">{`Nacionalidad: ${nacionalidad}`}</h6>
          {cud !== '' && (
            <div className="d-flex">
              <h6 className="m-3">{`CUD: ${cud}`}</h6>
              <Button variant="primary" className="w-10" onClick={() => handleVerCUD(idUser)}>
                Ver CUD
              </Button>
            </div>
          )}
          <Modal.Body>
            <CvUsuarioCongelado
              id={idUser}
              puesto={idPuesto}
              acciones={false}
              encabezado={false}
              requisitos={true}
              botonMas={false}></CvUsuarioCongelado>
            <br />
            <hr />
            <Seccion
              title="Validación de Requisitos Excluyentes"
              itemsComponent={
                <TablaValidacionRequisitos
                  requisitos={requisitosCargados}
                  requisitosValidadosFc={(requisitosValidados) => {
                    handleRequisitosValidados(requisitosValidados);
                  }}
                />
              }
            />
          </Modal.Body>
          <Modal.Footer>
            {((procesado && botoneraRechazadosSt) || (!procesado && !botoneraRechazadosSt)) && (
              <Button variant="success" onClick={() => handleAdmitir(idPostulantePuesto)}>
                Admitir
              </Button>
            )}
            {!botoneraRechazadosSt && (
              <Button variant="danger" onClick={() => handleRechazar(idPostulantePuesto)}>
                Rechazar
              </Button>
            )}

            <Button variant="secondary" onClick={handleClose}>
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {postulantes && (
        <>
          <h1>Postulantes en curso</h1>
          <Table striped bordered hover size="sm">
            <thead>
              <tr>
                <th>ID</th>
                <th>Apellido</th>
                <th>Nombre</th>
                <th>DNI</th>
                <th>Opciones</th>
              </tr>
            </thead>
            <tbody>
              {postulantes.postulantesAceptados.map(
                ({
                  apellido,
                  dni,
                  idPostulantePuesto,
                  idUsuario,
                  nombre,
                  fechaNacimiento,
                  nacionalidad,
                  numCud,
                  procesado,
                }) => {
                  return (
                    <>
                      <ColorTr procesado={procesado}>
                        <td>{idPostulantePuesto}</td>
                        <td>{apellido}</td>
                        <td>{nombre}</td>
                        <td>{dni}</td>
                        <td>
                          <div>
                            <Button
                              disabled={ocultarBotonCv}
                              className="m-2"
                              variant="primary"
                              size="sm"
                              onClick={() => {
                                handleShow(
                                  idUsuario,
                                  idPostulantePuesto,
                                  nombre,
                                  apellido,
                                  dni,
                                  fechaNacimiento,
                                  nacionalidad,
                                  numCud,
                                  procesado,
                                  false,
                                );
                              }}>
                              Ver CV
                            </Button>
                            {/*
                            <Button variant="secondary" size="sm" onClick={() => {}}>
                              Ver Requisitos
                            </Button>
                            */}
                          </div>
                        </td>
                      </ColorTr>
                    </>
                  );
                },
              )}
            </tbody>
          </Table>
        </>
      )}
      {postulantes && (
        <>
          <h1>Postulantes rechazados</h1>
          <Table striped bordered hover size="sm">
            <thead>
              <tr>
                <th>ID</th>
                <th>Apellido</th>
                <th>Nombre</th>
                <th>DNI</th>
                <th>Etapa Rechazo</th>
                <th>Opciones</th>
              </tr>
            </thead>
            <tbody>
              {postulantes.postulantesRechazados.map(
                ({
                  apellido,
                  dni,
                  etaparechazo,
                  idPostulantePuesto,
                  idUsuario,
                  nombre,
                  fechaNacimiento,
                  nacionalidad,
                  numCud,
                  procesado,
                }) => {
                  return (
                    <>
                      <ColorTr procesado={procesado}>
                        <td>{idPostulantePuesto}</td>
                        <td>{apellido}</td>
                        <td>{nombre}</td>
                        <td>{dni}</td>
                        <td>{etaparechazo}</td>
                        <td>
                          <div>
                            <Button
                              disabled={ocultarBotonCv}
                              variant="primary"
                              size="sm"
                              onClick={() => {
                                handleShow(
                                  idUsuario,
                                  idPostulantePuesto,
                                  nombre,
                                  apellido,
                                  dni,
                                  fechaNacimiento,
                                  nacionalidad,
                                  numCud,
                                  procesado,
                                  true,
                                );
                              }}>
                              Ver CV
                            </Button>
                            {/*
                            <Button variant="secondary" size="sm" onClick={() => {}}>
                              Ver Requisitos
                            </Button>
                            */}
                          </div>
                        </td>
                      </ColorTr>
                    </>
                  );
                },
              )}
            </tbody>
          </Table>
        </>
      )}
    </>
  );
};
